export const SEPARATORS_NAMES = {
  accepted: 'accepted',
  proposition: 'proposition',
  propositionsModified: 'propositionsModified',
  pending: 'pending',
  refused: 'refused',
  done: 'done',
}
